function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/ico-30-dots");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/ico-30-dots"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6,12.5 C7.38071187,12.5 8.5,13.6192881 8.5,15 C8.5,16.3807119 7.38071187,17.5 6,17.5 C4.61928813,17.5 3.5,16.3807119 3.5,15 C3.5,13.6192881 4.61928813,12.5 6,12.5 Z M24,12.5 C25.3807119,12.5 26.5,13.6192881 26.5,15 C26.5,16.3807119 25.3807119,17.5 24,17.5 C22.6192881,17.5 21.5,16.3807119 21.5,15 C21.5,13.6192881 22.6192881,12.5 24,12.5 Z M15,12.5 C16.3807119,12.5 17.5,13.6192881 17.5,15 C17.5,16.3807119 16.3807119,17.5 15,17.5 C13.6192881,17.5 12.5,16.3807119 12.5,15 C12.5,13.6192881 13.6192881,12.5 15,12.5 Z",
  id: "Combined-Shape",
  stroke: "#440070"
})));

const SvgIco30Dots = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Dots, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-dots.75f2a84b.svg";
export { ForwardRef as ReactComponent };